module.exports = __webpack_public_path__ + "static/media/3.2b94cea4.jpg";